import type { DefaultsEntry } from './config.types';
import { DOT_ORG_TEAM, NDAO_WALLETS } from './helpers';

export const testDefaults: DefaultsEntry = {
  confirmations: {
    donation: 2,
    wirePayout: 2,
    walletPayout: 2,
    portfolioTrade: 2,
    transfer: 2,
    setManager: 2,
    orgDeployment: 2,
    fundDeployment: 2,
  },
  fees: {
    fundDonationFeeBps: 50,
    orgDonationFeeBps: 150,
  },
  network: {
    defaultChainId: 11155111,
    supportedNetworkSettings: [
      {
        chainId: 84532,
        baseToken: {
          id: 389,
          symbol: 'USnDao',
          name: 'Endaoment USD',
          decimals: 6,
          logoUrl: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
          type: 'EvmToken',
          featured: false,
          popularity: 0,
          chainId: 84532,
          contractAddress: '0xa47d03511d313c4befbd2214c78788b8440a0808',
        },
        nativeToken: {
          id: 98,
          symbol: 'ETH',
          name: 'Ether',
          decimals: 18,
          logoUrl: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
          type: 'EvmToken',
          featured: true,
          popularity: 0,
          chainId: 84532,
          contractAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        },
        contracts: {
          registry: '0x51fc9f8ea263799ed8ef9461836278c4d51b89df',
          orgFundFactory: '0x11d59205facc286ab373535d570e44da1817854a',
          batchOrgDeployer: '0x0000000000000000000000000000000000000000',
          transferDeployer: '0xc519f7ea2cad0212af7cb05166ac9c4baaa19864',
          entityMulticall: '0x4f9e1716ba1094337221f5219ef162a51db6718e',
        },
      },
      {
        chainId: 11155111,
        baseToken: {
          id: 93,
          symbol: 'USDC',
          name: 'USDC',
          decimals: 6,
          logoUrl: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
          type: 'EvmToken',
          featured: true,
          popularity: 0,
          chainId: 11155111,
          contractAddress: '0x1c7d4b196cb0c7b01d743fbc6116a902379c7238',
        },
        nativeToken: {
          id: 90,
          symbol: 'ETH',
          name: 'Ether',
          decimals: 18,
          logoUrl: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
          type: 'EvmToken',
          featured: false,
          popularity: 0,
          chainId: 11155111,
          contractAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        },
        contracts: {
          registry: '0xf5ca418c59a9afe3be683bbe5d756ce4e54ed65d',
          orgFundFactory: '0xf93a0e957c4e33a99240a18f651e6adebbdf997b',
          batchOrgDeployer: '0x2bf99a48eb5c563a323699d8c5a52de146973194',
          transferDeployer: '0x0905ea282bcc6fa477bef258de25170343f23e2e',
          entityMulticall: '0xa6956ef5041b6cbc6793fd58b5fd6b06ea5737c8',
        },
      },
      {
        chainId: 11155420,
        baseToken: {
          id: 390,
          symbol: 'USnDao',
          name: 'Endaoment USD',
          decimals: 6,
          logoUrl: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
          type: 'EvmToken',
          featured: false,
          popularity: 0,
          chainId: 11155420,
          contractAddress: '0x542b346689537400b277e84808a9a07c1d824464',
        },
        nativeToken: {
          id: 103,
          symbol: 'ETH',
          name: 'Ether',
          decimals: 18,
          logoUrl: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
          type: 'EvmToken',
          featured: true,
          popularity: 0,
          chainId: 11155420,
          contractAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        },
        contracts: {
          registry: '0xf59b282cad6a31506efebb659eacce9af6d04a13',
          orgFundFactory: '0xc519f7ea2cad0212af7cb05166ac9c4baaa19864',
          batchOrgDeployer: '0x0000000000000000000000000000000000000000',
          transferDeployer: '0xcd8e2487223aeab004f414686a23b2627f91f771',
          entityMulticall: '0x3c750c082e9bc8f7c32b825f49c1101c8c9ac7dd',
        },
      },
    ],
  },
  roles: {
    accountant: ['0x70997970c51812dc3a010c7d01b50e0d17dc79c8'],
    maintainer: ['0x90f79bf6eb2c4f870365e785982e1f101e93b906'],
    reviewer: ['0x3c44cdddb6a900fa2b585dd299e03d12fa4293bc'],
    keeper: [...DOT_ORG_TEAM, NDAO_WALLETS.TEST_PAUSER_WALLET],
  },
  stripePublishableKey:
    'pk_test_51NvSLXKXyuJ3LOFN0l7ehahFm1vFfaWchEEhHVqSxwDrv9abIx9iYwLdttp7EKOqEScm61DQAsLJmW1jN5ybcsfH008qiCg7im',
};
